import React from 'react';
import { Link } from 'react-router-dom';
import { LAST_REVIEWED, CRM, formatarData } from '../data/revision';

const Footer = () => {
  const ano = LAST_REVIEWED.slice(0, 4);

  return (
    <footer className="site-footer">
      <div className="page site-footer__grid">
        <div className="site-footer__brand">
          <strong>Escala de Glasgow</strong>
          <p>
            Calculadora e conteúdo clínico sobre a Escala de Coma de Glasgow, com revisão médica e processamento local no navegador.
          </p>
          <span>{CRM} · revisão {formatarData(LAST_REVIEWED)}</span>
          <p>
            Dúvida de conduta depois da escala?{' '}
            <a href="https://douto.app/neurologia/?utm_source=glasgow&utm_medium=calculadora&utm_campaign=rodape&utm_content=glasgow_conduta">
              Pergunte ao Douto
            </a>
            , apoio à decisão clínica com a fonte citada. O primeiro caso é grátis.
          </p>
        </div>

        <nav className="site-footer__nav" aria-label="Conteúdo">
          <strong>Conteúdo</strong>
          <Link to="/tabela">Tabela da Escala de Glasgow</Link>
          <Link to="/pediatrica">Glasgow pediátrica</Link>
          <Link to="/ecg-p">ECG-P e pupilas</Link>
          <Link to="/como-avaliar">Como avaliar</Link>
          <Link to="/referencias">Referências</Link>
          <a href="/escala-de-glasgow.pdf">PDF A4 para impressão</a>
        </nav>

        <div className="site-footer__nav">
          <strong>Projeto</strong>
          <Link to="/sobre">Sobre este site</Link>
          <Link to="/privacidade">Privacidade</Link>
          <Link to="/termos">Termos de uso</Link>
          <a
            className="site-footer__eidoc"
            href="https://eidoc.com.br/ferramentas"
            target="_blank"
            rel="noopener noreferrer"
          >
            Conheça outras ferramentas médicas na Ei Doc ↗
          </a>
        </div>
      </div>

      <div className="page site-footer__bottom">
        <span>© {ano} escaladeglasgow.com.br</span>
        <span>Conteúdo educacional; interpretação sempre depende do contexto clínico.</span>
      </div>
    </footer>
  );
};

export default Footer;
